import React, { useCallback, useEffect, useState } from "react"
import { Row, Button } from "antd"
import { useHistory } from "react-router-dom"
import { useStore } from "hooks"
import { general } from "store"
import { endpoints } from "config/endpoints.config"
import request from "lib/request"
import FacebookLogin from "@greatsumini/react-facebook-login"
import { envKeys } from "config/envs.config"
import { isAldeia } from "hooks/useAldeia"
import StarAlert from "../../StarAlert"
import { channelsDef } from "../../channels.def"
import { IChannel } from "models/channels"
import toast from "lib/toast"
import Lottie from "react-lottie"
import whatsappLottie from "assets/animations/whatsapp.json"

interface AddWhatsappEmbeddedProps {}

const loadingLottieOptions = {
  loop: true,
  autoplay: true,
  animationData: whatsappLottie,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
}

function AddWhatsappEmbedded(props: AddWhatsappEmbeddedProps) {
  const [data, setData] = useState<{
    code?: string
    expiresIn?: number
    userID?: string
  }>({})
  const [dataAsync, setDataAsync] = useState<{
    business_id?: string
    phone_number_id?: string
    waba_id?: string
  }>({})

  const history = useHistory()
  // const setModal = useSetAtom(modalState)
  const [loading, setLoading] = useState(false)

  const { _domain, _isProduction } = useStore(general)
  const isStaging = !_isProduction
  // const isStaging = true
  const appId = isStaging ? "2243536099417022" : ((envKeys as any)[_domain.key] || {}).facebook_app_id || envKeys.staging.facebook_app_id

  const handleMessage = useCallback((event: any) => {
    if (!event.origin.endsWith("facebook.com")) return
    try {
      const data = JSON.parse(event.data)
      if (data.type === "WA_EMBEDDED_SIGNUP") {
        console.log("message event: ", data) // remove after testing
        setDataAsync((d) => ({
          ...d,
          business_id: data.data.business_id,
          phone_number_id: data.data.phone_number_id,
          waba_id: data.data.waba_id,
        }))
      }
    } catch (error) {
      console.log("error: ", error)
      // console.log("message event: ", event.data) // remove after testing
      // your code goes here
    }
  }, [])

  useEffect(() => {
    // Session logging message event listener
    window.addEventListener("message", handleMessage)

    return () => {
      window.removeEventListener("message", handleMessage)
    }
  }, [])

  useEffect(() => {
    if (!data.code || !dataAsync?.phone_number_id || !dataAsync?.waba_id) return

    try {
      setLoading(true)
      const hide = toast.loading("Conectando canal de WhatsApp...")

      request
        .post<IChannel>(endpoints.WHATSAPP_WBA_CLOUD, {
          description: dataAsync.phone_number_id,
          signUpData: {
            business_id: dataAsync.business_id!,
            phone_number_id: dataAsync.phone_number_id!,
            waba_id: dataAsync.waba_id!,
            code: data.code,
          },
        })
        .then(async ({ data: channel }) => {
          toast.success("Canal de WhatsApp conectado.")
          history.push("/settings/channels")

          // await request
          //   .post(endpoints.WHATSAPP_WBA_CLOUD_SAVE_EMBEDDED_SIGNUP_DATA + "/" + channel.id, {
          //     workspacePlatformId: channel.id,
          //     signUpData: {
          //       business_id: dataAsync.business_id!,
          //       phone_number_id: dataAsync.phone_number_id!,
          //       waba_id: dataAsync.waba_id!,
          //       code: data.code,
          //     },
          //   })
          //   .then(() => {
          //     toast.success("Canal de WhatsApp conectado.")
          //   })
          //   .catch((e) => {
          //     toast.error("Erro ao registrar canal de WhatsApp na Meta.")
          //   })
          //   .finally(() => {
          //     hide?.()
          //     history.push("/settings/channels")
          //   })
        })
        .catch((e) => {
          console.log(e)
          toast.error("Erro ao conectar canal de WhatsApp.")
          setData({})
          setDataAsync({})
        })
        .finally(() => {
          setLoading(false)
          hide?.()
        })
    } catch (error) {
      setLoading(false)
      history.push("/settings/channels/new/whatsapp")
      console.log("error: ", error)
    }

    // setModal(
    //   <AddWhatsappEmbeddedDrawer
    //     business_id={dataAsync.business_id!}
    //     phone_number_id={dataAsync.phone_number_id!}
    //     waba_id={dataAsync.waba_id!}
    //     code={data.code}
    //     onClose={() => setModal(null)}
    //   />,
    // )
  }, [data.code, dataAsync?.phone_number_id, dataAsync?.business_id, dataAsync?.waba_id])

  const configId = isStaging ? "583283534716831" : "784671293694060"
  // const configId = isStaging ? "940158693825848" : "940158693825848"

  const stepAlerts = (
    <>
      <p>
        Vamos integrar seu WhatsApp com o Kinbox. Para isso, clique no botão abaixo e habilite os números que você quer integrar no WhatsApp
        no popup que vai aparecer.
      </p>
    </>
  )

  return (
    <>
      {isAldeia ? <StarAlert className="mt-2 mb-5">{stepAlerts}</StarAlert> : <p>{stepAlerts}</p>}

      <div>
        <br />
        <Row justify="center">
          {loading ? (
            <div className="h-36 fc">
              <div className="absolute top-1/2 left-1/2 rounded-full -translate-x-1/2 -translate-y-1/2 size-40"></div>
              <div className="-mt-12 fc">
                <Lottie options={loadingLottieOptions} height={150} width={150} speed={1} />
              </div>
            </div>
          ) : (
            <FacebookLogin
              appId={appId}
              scope="whatsapp_business_management, whatsapp_business_messaging"
              initParams={
                {
                  version: "v19.0",
                } as any
              }
              language="pt_BR"
              onSuccess={(response: any) => {
                setData((d) => ({
                  ...d,
                  code: response.code,
                  expiresIn: response.expiresIn,
                  userID: response.userID,
                }))
              }}
              onFail={(error) => {
                console.log("Login Failed!", error)
              }}
              onProfileSuccess={(response) => {
                console.log("Get Profile Success!", response)
              }}
              loginOptions={
                {
                  config_id: configId,
                  response_type: "code",
                  override_default_response_type: true,
                  extras: {
                    // featureType: "whatsapp_business_app_onboarding",
                    setup: {},
                    // featureType: "only_waba_sharing", // set to only_waba_sharing
                    sessionInfoVersion: "3",
                    featureType: "whatsapp_business_app_onboarding",
                    // setup: {
                    //   ... // Prefilled data can go here
                    // }
                  },
                } as any
              }
              render={({ onClick }) => (
                <Button
                  icon={<div className="size-[22px] !mr-2 [&_svg]:!text-white">{channelsDef.record["whatsapp"]?.icon}</div>}
                  size="large"
                  onClick={onClick}
                  className="!bg-[#21ac66] hover:!bg-[#1a9b5a] !text-white !font-semibold dark:!bg-green-600 dark:hover:!bg-green-700"
                  loading={loading}
                >
                  Conectar WhatsApp
                </Button>
              )}
            />
          )}
        </Row>
      </div>
      {/* {step == 1 && <Step2 accessToken={data?.access_token!} type={props.type} onBack={() => setStep(0)} />} */}
      <br />
    </>
  )
}

export default AddWhatsappEmbedded
